import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
  selector: 'gd-type-editor-firm-type',
  templateUrl: './type-editor-firm-type.component.html',
  styleUrls: ['./type-editor-firm-type.component.scss'],
  imports: [
    CommonModule,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    ButtonComponent,
    ColumnComponent,
    EditTemplateDirective,
    TextBoxDirective,
    FormsModule,
    ReactiveFormsModule,
    CellTemplateDirective,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
  ]
})
export class TypeEditorFirmTypeComponent extends GridEditorBaseComponent {
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getFirmTypes().subscribe((response) => {
      this.repState.firmTypeList = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const firmType = formGroup.value
    this.typesService.submitFirmTypeUpdate(firmType).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        firmTypeID: 0,
        firmTypeDescription: null,
        typeOfFirm: null,
        typeOfFirmID: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(firmType: any): UntypedFormGroup {
    return this.formBuilder.group({
      firmTypeID: firmType.firmTypeID,
      firmTypeDescription: [firmType.firmTypeDescription, Validators.required],
      typeOfFirm: firmType.typeOfFirm,
      typeOfFirmID: [firmType.typeOfFirmID, Validators.required],
      active: firmType.active,
    })
  }
}
